<template>
    <div>
        <div class="row" id="headlines-page">
            <div class="col-lg-12 mt-3 text-center" id="headlines">
                <div class="headline-item mb-1 d-none"></div>
                <div class="headline-item mb-1 d-none"></div>
                <div :class="{active: $route.name === 'saleMali'}" class="headline-item mb-1" @click="onHeadlineClicked('saleMali')">
                    <h5>تعریف سال مالی</h5>
                </div>
                <div :class="{active: $route.name === 'accountOutSource'}" class="headline-item mb-1" @click="onHeadlineClicked('accountOutSource')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>تعریف سرفصل حساب</h5>
                </div>
                <!--<div :class="{active: $route.name === 'accountPayment'}" class="headline-item mb-1" @click="onHeadlineClicked('accountPayment')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">-->
                    <!--<h5>دریافت و پرداخت</h5>-->
                <!--</div>-->
                 <div :class="{active: $route.name === 'accountPaymentList'}" class="headline-item mb-1" @click="onHeadlineClicked('accountPaymentList')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>اسناد حسابداری</h5>
                </div>
                <div :class="{active: $route.name === 'accountCobine'}" class="headline-item mb-1" @click="onHeadlineClicked('accountCobine')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>ادغام اسناد</h5>
                </div>
                <!--<div :class="{active: $route.name === 'addPayment'}" class="headline-item mb-1" @click="onHeadlineClicked('addPayment')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">-->
                    <!--<h5>ثبت سند</h5>-->
                <!--</div>-->
                <div :class="{active: $route.name === 'accountBalanceReport'}" class="headline-item mb-1" @click="onHeadlineClicked('accountBalanceReport')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>تراز آزمایشی</h5>
                </div>
                <div :class="{active: $route.name === 'closeSaleMali'}" class="headline-item mb-1" @click="onHeadlineClicked('closeSaleMali')" v-if="companyPostName === 'صندوق دار' || companyPostName === 'مدیر'">
                    <h5>بستن حسابهای سال مالی</h5>
                </div>
            </div>
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
            <div class="sk-circle" id="loadings">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'haedlines',
        components: {},
        data() {
            return {
                providers: [],
                categories: [],
                queryParams: {
                    pageSize: 18,
                    pageIndex: 0,
                    name: "",
                    categoryId: 0
                },
                searchString: "",
                modalProductName: "",
                companyPostName: "",
                cart: []
            }
        },
        mounted() {
            this.companyPostName = localStorage.getItem("companyPostName");

            $("#loadings").hide();
        },
        methods: {
            onHeadlineClicked(headline) {
                this.$router.push({
                    name: `${headline}`,

                });
            }
        }
    }
</script>

<style scoped>
    #loading {
        position: absolute;
        top: calc(40% - 40px);
        left: calc(50% - 40px);
    }
</style>